import VueCookies from "vue-cookies";
import i18n from "@/plugins/i18n";



class LanguageStore {
    constructor() {
        this.state = {
            lang: null,
        }
    }


    setLang(lang) {
        
        this.lang = lang;
        i18n.locale = lang;
        VueCookies.set(
            "lang_cookie",
            lang,
            null,
            null,
            null,
            null,
            "lax"
        );
    }

    getLang() {
        return this.lang;
    }

    initializeLang() {
        let cookie = VueCookies.get("lang_cookie");
        if (cookie) { this.lang = cookie; }
        else { this.lang = 'en' }
        i18n.locale = this.lang;
    }

}

export default new LanguageStore();
